import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import LocationGroupSelection from 'modules/surveys/components/LocationGroupSelection'
import TeamGroupSelection from 'modules/surveys/components/TeamGroupSelection'

interface Props {
  groupField: Field
  groupableIdField: Field
  disabled?: boolean
}

function DynamicGroupSelection({ disabled = false, groupField, groupableIdField }: Props) {
  const { location, team } = AccessGroup.GroupableTypes

  const groupOptions = React.useRef([
    {
      value: team,
      label: i18n.t('surveys.new.form.labels.team'),
    },
    {
      value: location,
      label: i18n.t('surveys.new.form.labels.office'),
    },
  ]).current

  return (
    <Box gap="s16">
      <Select
        none={i18n.t('common.none')}
        readonly={disabled}
        field={groupField}
        options={groupOptions}
      />
      {groupField.value === team && (
        <TeamGroupSelection readonly={disabled} field={groupableIdField} />
      )}
      {groupField.value === location && (
        <LocationGroupSelection readonly={disabled} field={groupableIdField} />
      )}
    </Box>
  )
}

export default observer(DynamicGroupSelection)
